import React from 'react';
import classnames from 'classnames';

interface FooterProps {
  children?: React.ReactNode;
  className?: string;
  style?: {};
}

const Footer = ({
  children,
  className,
  style = {},
}: FooterProps): JSX.Element => {
  return (
    <footer style={style} className={classnames('footer', className)}>
      <div>{children}</div>
    </footer>
  );
};

export default Footer;
